import React from 'react'
import { useMutation } from '@apollo/client'
import { TestResult, EditTestResults, EditTestResultsVariables } from '@modmd/data'
import { SelectInput } from 'components/SelectInput'
import Button from 'components/Button'
import Card from 'components/Card'
import { Dialog } from 'components/Dialog'
import { Loading } from 'components/Loading'
import { EDIT_TEST_RESULTS, GET_TEST } from './operations'

interface Props {
  isOpen: boolean
  testId: string
  result?: TestResult | null
  onClose: () => void
  secondResult?: boolean
}

export const ChangeTestResultDialog = ({
  isOpen,
  testId,
  result,
  onClose,
  secondResult,
}: Props) => {
  const [testResult, setTestResult] = React.useState(result)
  const [editTestResults, editTestResultsData] = useMutation<
    EditTestResults,
    EditTestResultsVariables
  >(EDIT_TEST_RESULTS, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GET_TEST,
        variables: {
          id: testId,
        },
      },
    ],
  })
  const handleSave = async () => {
    try {
      await editTestResults({
        variables: {
          inputData: {
            result: secondResult ? undefined : testResult,
            secondResult: secondResult ? testResult : undefined,
            testIds: [testId],
            resultManuallyEntered: true,
          },
        },
      })
      onClose()
    } catch {
      // ignore error
    }
  }
  return (
    <Dialog isOpen={isOpen} onDismiss={onClose} maxWidth="500px">
      <Loading isLoading={editTestResultsData.loading}>
        <Card>
          <Card.Title onDismiss={onClose}>Change test result</Card.Title>
          <Card.Content>
            <SelectInput
              value={testResult || ''}
              onChange={(event) => setTestResult(event.target.value as TestResult)}
              options={[
                { value: '', label: 'No result', disabled: true },
                ...Object.values(TestResult).map((value) => ({ value, label: value })),
              ]}
            />
          </Card.Content>
          <Card.Actions>
            <Button onClick={onClose} colorVariant="danger" appearance="ghost">
              Cancel
            </Button>
            <Button
              isFetching={editTestResultsData.loading}
              disabled={testResult === result}
              onClick={handleSave}
            >
              Save
            </Button>
          </Card.Actions>
        </Card>
      </Loading>
    </Dialog>
  )
}
